module.exports = function() {
  return new Worker(__webpack_public_path__ + "348e184ef4b5c7fdb585.worker.js");
};